import type { AnswerRequest } from "../types";

export const isAnswerRequestEmpty = (answerValue: AnswerRequest["value"] | undefined): boolean => {
  if (!answerValue) return true;
  if (Array.isArray(answerValue)) return answerValue.length === 0;
  return false;
};
